// extracted by mini-css-extract-plugin
export default {"page-loading-container":"LoadingPage_page-loading-container__JFTKk","page-loading-spinner":"LoadingPage_page-loading-spinner__XxtVU","stretch":"LoadingPage_stretch__Llbe1"};